import { render, staticRenderFns } from "./section-2.vue?vue&type=template&id=0428b4e7&"
import script from "./section-2.vue?vue&type=script&lang=js&"
export * from "./section-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports